import { render, staticRenderFns } from "./wb-workbench-props.vue?vue&type=template&id=0748ddfc&scoped=true"
import script from "./wb-workbench-props.vue?vue&type=script&lang=js"
export * from "./wb-workbench-props.vue?vue&type=script&lang=js"
import style0 from "./wb-workbench-props.vue?vue&type=style&index=0&id=0748ddfc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0748ddfc",
  null
  
)

export default component.exports